import React, { useEffect, useState } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';

import { ItemTypes } from '../taskDnD/dndConstants';
import { STATUSES } from '../../globals/workOrderStatus';
import AdminContextMenu from '../contextMenu';

import 'react-calendar-timeline/lib/Timeline.css';
import './gantt.css';

export const GanttItem = (props) => {
    const { item, itemContext, itemProps, notSelected } = props;

    const overlap = item.overlap > 0 ? " overlap" : "";
    const taskCompleted = item?.status && item?.status?.id === STATUSES.PENDING_REVIEW ? " task-status-completed": "";

    const [{ isDragging }, drag, preview] = useDrag({
        item: { type: ItemTypes.TASK, id: item?.workOrderNumber, duration: item?.duration },
        canDrag: (item?.status?.id === STATUSES.UNASSIGNED || item?.status?.id === STATUSES.ASSIGNED),
        collect: (monitor) => ({
          isDragging: monitor.isDragging(),
        }),
    })
    
    useEffect(() => {
        preview(getEmptyImage(), { captureDraggingState: true })
    }, [])


    const notSelectedClass = notSelected ? " not-selected" : "";

    return (
       
            <div
                ref={notSelected ? null : drag}
                className={"rct-item-content cmis-gantt-item sticky " + overlap + notSelectedClass}
                style={{ maxHeight: `${itemContext.dimensions.height}` }}
            >
                <div 
                    className={"cmis-gantt-item-tab " + item.type + taskCompleted}
                />
                
                <div
                    className={"cmis-gantt-wo-title " + item.type + taskCompleted}
                    style={{ maxWidth: '28px' }}
                >
                    {props.children}
                </div>
            </div>
    );
}

export const GanttWorkOrder = (props) => {
    const { item } = props;
    const overlap = item.overlap > 0 ? " overlap" : "";
    return (
        <GanttItem
            {...props}
        >
            <AdminContextMenu 
                task={item}
                from="gantt-view" 
                overlap={overlap} 
            />
        </GanttItem>
    );
}

export const GanttBlockout = (props) => {
    // const { item, itemContext } = props;
    // const overlap = item.overlap > 0 ? " overlap" : "";
    return (
        <GanttItem>
            <div className="cmis-gantt-wo-caption">
                Unavailable
            </div>
        </GanttItem>
    );
}

